export default ( top=0, offset=0, speed=0.4 ) => {
	for( let i = document.documentElement.scrollTop; i<=(top-offset); i+=1 ) {
		setTimeout( () => window.scrollTo(0, i), speed*i);
	}
}
